/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useCallback, useContext, useState } from 'react';

export interface UIContextValue {
  showSideMenu: boolean;
  toggleSideMenu: () => void;
  openSideMenu: () => void;
  closeSideMenu: () => void;

  showDepositTray: boolean;
  openDepositTray: () => void;
  closeDepositTray: () => void;
  setShowDepositTray: (open: boolean) => void;
}

export const UIContext = createContext<UIContextValue | undefined>(undefined);

export function UIProvider({ children }: { children: React.ReactNode }) {
  const [showSideMenu, setShowSideMenu] = useState(false);
  const [showDepositTray, setShowDepositTray] = useState(false);

  const toggleSideMenu = useCallback(() => setShowSideMenu(v => !v), []);
  const openSideMenu = useCallback(() => setShowSideMenu(true), []);
  const closeSideMenu = useCallback(() => setShowSideMenu(false), []);

  const openDepositTray = useCallback(() => setShowDepositTray(true), []);
  const closeDepositTray = useCallback(() => setShowDepositTray(false), []);

  const value = {
    showSideMenu,
    toggleSideMenu,
    openSideMenu,
    closeSideMenu,
    showDepositTray,
    openDepositTray,
    closeDepositTray,
    setShowDepositTray,
  };

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI(): UIContextValue {
  const ctx = useContext(UIContext);
  if (!ctx) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return ctx;
}
